module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kaklQ"))).then(() => parcelRequire('ljYL6'));